import type { AddTabToWorkspaceOptions } from 'epic/workspace/common/tabs/tabsEpics';
import { openTabInWorkspaceEpic } from 'epic/workspace/common/tabs/tabsEpics';
import type { SecondaryMarketQuoteByIsinReloadRequested } from 'state/secondaryMarket/realtimeQuote/quote';
import type { EpicWithThunk } from 'state/state.common';
import { secondaryQuoteByIsinOrFileCodeReloadThunk } from 'state/workspaces/secondary-market/quotes/secondaryMarketQuotes.thunks';

export function secondaryWorkspaceReloadByIsinEpic(): EpicWithThunk {
  const opt: AddTabToWorkspaceOptions<SecondaryMarketQuoteByIsinReloadRequested> = {
    workspaceReadyTriggers: ['WORKSPACE_PERSISTED_TABS_APPLIED', 'WORKSPACE_TAB_CREATED'],
    targetWorkspace: 'secondaryMarketQuotes',
    triggers: ['SECONDARY_MARKET_QUOTE_BY_ISIN_RELOAD_REQUESTED'],
    navigateRoute: { path: '/secondary-market-quotes-workspace' },
    onReady: ({ isin, blotterType }) => secondaryQuoteByIsinOrFileCodeReloadThunk(isin, blotterType),
  };
  return openTabInWorkspaceEpic(opt);
}
